var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{attrs:{"xs6":"","sm5":""}},[_c('v-text-field',{attrs:{"label":"Nome do Pagador","persistent-hint":"","single-line":""},model:{value:(_vm.payerName),callback:function ($$v) {_vm.payerName=$$v},expression:"payerName"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }